if (!customElements.get('origin-campaign-gallery')) {
  customElements.define('origin-campaign-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-origin-zoom]');
        if (trigger) {
          const source = trigger.querySelector('img');
          const enlarged = dialog.querySelector('img');
          enlarged.src = source.currentSrc || source.src;
          enlarged.alt = source.alt;
          this.opener = trigger;
          dialog.showModal();
        } else if (event.target.closest('[data-origin-close]') || event.target === dialog) {
          dialog.close();
        }
      }, { signal: this.controller.signal });
      dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
